export const BASE_URL = "https://trueexams.in/api/v1";
// export const BASE_URL = "http://192.168.1.7:4001/api/v1";


export const getWithTokenAPI = async (token, endpoint) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;
    console.log("Making API call to:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log("API Response status:", response.status);
    console.log("API Response headers:", response.headers);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { error: true, message: error.message };
  }
};

export const getWithoutTokenAPI = async (endpoint) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;
    console.log("Making API call to:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("API Response status:", response.status);
    console.log("API Response headers:", response.headers);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { error: true, message: error.message };
  }
};

export const postWithTokenAPI = async (token, endpoint, payload) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;

    console.log("Making API call to:", url);

    const isFormData = payload instanceof FormData;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // ✅ Only set JSON header when NOT sending FormData
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
      body: isFormData ? payload : JSON.stringify(payload),
    });

    console.log("API Response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { error: true, message: error.message };
  }
};

export const postWithoutTokenAPI = async (endpoint, payload) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;
    console.log("Making API call to:", url);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    console.log("API Response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { error: true, message: error.message };
  }
};

export const putWithTokenAPI = async (token, endpoint, payload) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;
    console.log("Making API call to:", url);

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    console.log("API Response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { error: true, message: error.message };
  }
};
export const deleteWithTokenAPIpayload = async (
  token,
  endpoint,
  payload = null,
) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;

    console.log("Making API call to:", url);
    console.log("Payload:", payload);

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: payload ? JSON.stringify(payload) : null,
    });

    console.log("API Response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { error: true, message: error.message };
  }
};

export const deleteWithTokenAPI = async (token, endpoint) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;
    console.log("Making API call to:", url);

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log("API Response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { error: true, message: error.message };
  }
};

export const deleteWithTokenBodyAPI = async (token, endpoint, data) => {
  try {
    const url = endpoint.startsWith("http")
      ? endpoint
      : `${BASE_URL}${endpoint}`;

    console.log("Making DELETE API call to:", url);

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data), // ✅ include body data
    });

    console.log("Response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log("Response data:", result);

    return result;
  } catch (error) {
    console.error("❌ Delete API Error:", error);
    return { error: true, message: error.message };
  }
};

// In your Api.js file, update postWithoutTokenAPI:
export const ImageUpload = async (url, data, isMultipart = false) => {
  try {
    let headers = {};

    if (!isMultipart) {
      headers["Content-Type"] = "application/json";
    }
    // For multipart, don't set Content-Type - browser will set it automatically

    const response = await fetch(`${BASE_URL}${url}`, {
      method: "POST",
      headers,
      body: isMultipart ? data : JSON.stringify(data),
    });

    return await response.json();
  } catch (error) {
    throw error;
  }
};
